// extracted by mini-css-extract-plugin
export default {"container":"hO-z","topReviewHeading":"iO-z","criticalReview":"jO-z","favorableReview":"kO-z","vsSeparator":"lO-z"};